<section class="main-login">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 mb-3">
        <div class="login__content">
          <div class=" row justify-content-center mb-2 pb-3">
            <img src="assets/logos/logo-inprovider.png" [attr.alt]="brandName" class="imgSizes">
          </div>
          <form #form="ngForm" (ngSubmit)="onLogin(form)">
            <div class="form-group">
              <input [(ngModel)]="credentials.email" name="usuario" #_email="ngModel"
                type="email" class="form-control" placeholder="Usuario"
                required pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                >
              @if (_email.dirty && _email.invalid) {
                <ul class="text-danger list-unstyled pt-1"
                  >
                  @for (error of getValidationMessages(_email); track error) {
                    <li>
                      {{error}}
                    </li>
                  }
                </ul>
              }
            </div>
            <div class="form-group mb-4">
              <div class="password-input-wrapper">
                <input [(ngModel)]="credentials.password" name="password" #_password="ngModel"
                  [type]="showPassword ? 'text' : 'password'" class="form-control"
                  placeholder="Contraseña" required autocomplete="current-password">
                <button type="button" class="password-toggle-btn"
                  (click)="showPassword = !showPassword"
                  [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                  <i class="far" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
              @if (_password.dirty && _password.invalid) {
                <ul class="text-danger list-unstyled pt-1"
                  >
                  @for (error of getValidationMessages(_password); track error) {
                    <li>
                      {{error}}
                    </li>
                  }
                </ul>
              }
            </div>
            @if (errorMessage !== undefined) {
              <p class="errorMsg"> {{ errorMessage }} </p>
            }
            <button type="submit"
              class="btn btn-outline-primary rounded-pill px-5 mx-auto d-block"
              [disabled]="domainNotConfigured"
              >
              Ingresar
            </button>
          </form>

          <div class="oauth-divider">
            <span>o ingresa con</span>
          </div>

          <div class="oauth-buttons">
            <button class="oauth-btn google-btn" (click)="loginWithGoogle()" type="button" [disabled]="domainNotConfigured">
              <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
              Google
            </button>
            <button class="oauth-btn microsoft-btn" (click)="loginWithMicrosoft()" type="button" [disabled]="domainNotConfigured">
              <svg width="18" height="18" viewBox="0 0 21 21"><rect x="1" y="1" width="9" height="9" fill="#f25022"/><rect x="1" y="11" width="9" height="9" fill="#00a4ef"/><rect x="11" y="1" width="9" height="9" fill="#7fba00"/><rect x="11" y="11" width="9" height="9" fill="#ffb900"/></svg>
              Microsoft
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-6 text-center">
        @if (!domainNotConfigured) {
          <a type="button" class="forgetPass" (click)="changePassword()">¿Olvidaste tu contraseña?</a>
        }
      </div>
    </div>
  </div>
</section>
